module.exports = "img/flags/JO.f226a55.png";